import React from "react";

export default function BruteFooter() {
  return (
    <footer className="brute-footer">
      <style>{`
        .brute-footer {
          position: relative;
          z-index: 4;
          background: #F4E9DC;
          border-top: 3px solid #1A1416;
          padding: 28px clamp(20px, 5vw, 64px);
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          flex-wrap: wrap;
          font-family: "Syne", "Archivo Black", system-ui, sans-serif;
          color: #1A1416;
        }
        .brute-footer__brand {
          display: flex;
          align-items: baseline;
          gap: 14px;
          flex-wrap: wrap;
          min-width: 0;
        }
        .brute-footer__wordmark {
          font-family: "Archivo Black", "Syne", system-ui, sans-serif;
          font-size: clamp(28px, 4vw, 40px);
          line-height: 1;
          letter-spacing: -0.02em;
          color: #1A1416;
          text-decoration: none;
          position: relative;
          display: inline-block;
          padding-bottom: 6px;
          border-bottom: 4px solid #FF5A1F;
        }
        .brute-footer__dot {
          display: inline-block;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #E6197C;
          border: 2px solid #1A1416;
          margin-left: 6px;
          transform: translateY(-10px) rotate(-2deg);
        }
        .brute-footer__tag {
          font-family: "Syne", system-ui, sans-serif;
          font-size: 12px;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #7A6A62;
          font-weight: 700;
        }
        .brute-footer__right {
          display: flex;
          align-items: center;
          gap: 22px;
          flex-wrap: wrap;
        }
        .brute-footer__links {
          display: flex;
          align-items: center;
          gap: 18px;
          flex-wrap: wrap;
        }
        .brute-footer__link {
          font-family: "Syne", system-ui, sans-serif;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          color: #1A1416;
          text-decoration: none;
          border-bottom: 2px solid transparent;
          padding-bottom: 2px;
          transition: color 0.15s ease, border-color 0.15s ease;
        }
        .brute-footer__link:hover,
        .brute-footer__link:focus-visible {
          color: #E6197C;
          border-bottom-color: #E6197C;
          outline: none;
        }
        .brute-footer__trust {
          font-family: "JetBrains Mono", ui-monospace, "SFMono-Regular", Menlo, monospace;
          font-size: 13px;
          letter-spacing: 0.04em;
          color: #7A6A62;
          white-space: nowrap;
        }
        .brute-footer__trust strong {
          color: #1A1416;
          font-weight: 700;
        }
        @media (max-width: 720px) {
          .brute-footer {
            flex-direction: column;
            align-items: flex-start;
            gap: 18px;
            padding: 24px 20px;
          }
          .brute-footer__right {
            flex-direction: column;
            align-items: flex-start;
            gap: 14px;
          }
          .brute-footer__trust {
            white-space: normal;
          }
        }
      `}</style>

      <div className="brute-footer__brand">
        <a className="brute-footer__wordmark" href="/">
          Brute
          <span className="brute-footer__dot" aria-hidden="true" />
        </a>
        <span className="brute-footer__tag">Password strength &amp; credential testing</span>
      </div>

      <div className="brute-footer__right">
        <nav className="brute-footer__links" aria-label="Footer">
          <a className="brute-footer__link" href="/">
            Home
          </a>
          <a className="brute-footer__link" href="/login">
            Log in
          </a>
          <a className="brute-footer__link" href="/sign-up">
            Create account
          </a>
        </nav>
        <span className="brute-footer__trust">
          <strong>LOCAL-FIRST</strong> · WINDOWS · NO CLOUD REQUIRED
        </span>
      </div>
    </footer>
  );
}
